import * as React from "react";
import isEqual from "lodash/isEqual";
import { useFormikContext } from "formik";
import styled from "styled-components";
import useUserDateTime from "hooks/useUserDateTime";
import { onInitializingTimerange } from "views/components/TimerangeForForm";
import { normalizeFromSearchBarForBackend } from "views/logic/queries/NormalizeTimeRange";
import Icon from "components/common/Icon";
import { Button } from "components/bootstrap";
import { isNoTimeRangeOverride } from "views/typeGuards/timeRange";
import { readableDifference } from "util/DateTime";
const DIRECTIONS = {
  backward: "backward",
  forward: "forward"
};
const DIRECTION_ICONS = {
  [DIRECTIONS.backward]: "keyboard_arrow_left",
  [DIRECTIONS.forward]: "keyboard_arrow_right"
};
const ArrowButton = styled(Button)`
  padding: 0;
  border: 0;
`;
const MoveRangeButton = ({
  direction,
  disabled,
  onMoveRange,
  title
}) => {
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onMoveRange(direction);
  };
  return /* @__PURE__ */ React.createElement(ArrowButton, { onClick, disabled, title }, /* @__PURE__ */ React.createElement(Icon, { name: DIRECTION_ICONS[direction] }));
};
const MoveRangeInner = ({
  setCurrentTimeRange,
  effectiveTimerange,
  initialTimerange,
  currentTimerange,
  children = void 0,
  initialTimerangeFormat
}) => {
  const { formatTime, userTimezone } = useUserDateTime();
  const { submitForm, isValid } = useFormikContext();
  const readableDuration = effectiveTimerange ? readableDifference(effectiveTimerange.from, effectiveTimerange.to) : void 0;
  if (effectiveTimerange) {
    readableDifference(effectiveTimerange.from, effectiveTimerange.to);
  }
  const onMoveRange = (direction) => {
    const currentFrom = new Date(effectiveTimerange.from);
    const currentTo = new Date(effectiveTimerange.to);
    const currentDurationMs = currentTo.getTime() - currentFrom.getTime();
    const isBackwardDirection = direction === DIRECTIONS.backward;
    const newFrom = (isBackwardDirection ? new Date(currentFrom.getTime() - currentDurationMs) : currentTo).toISOString();
    const newTo = (isBackwardDirection ? currentFrom : new Date(currentTo.getTime() + currentDurationMs)).toISOString();
    setCurrentTimeRange(onInitializingTimerange({ type: "absolute", from: newFrom, to: newTo }, formatTime));
    submitForm();
  };
  const disableButton = !effectiveTimerange || !isValid || isNoTimeRangeOverride(currentTimerange) || !isEqual(
    initialTimerange,
    normalizeFromSearchBarForBackend(currentTimerange, userTimezone, initialTimerangeFormat)
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    MoveRangeButton,
    {
      onMoveRange,
      disabled: disableButton,
      direction: DIRECTIONS.backward,
      title: disableButton ? "Show previous" : `Show previous ${readableDuration}`
    }
  ), children, /* @__PURE__ */ React.createElement(
    MoveRangeButton,
    {
      onMoveRange,
      disabled: disableButton,
      direction: DIRECTIONS.forward,
      title: disableButton ? "Show next" : `Show next ${readableDuration}`
    }
  ));
};
const MoveRange = ({
  displayMoveRangeButtons,
  setCurrentTimeRange,
  effectiveTimerange,
  initialTimerange,
  initialTimerangeFormat,
  currentTimerange,
  children = void 0
}) => {
  if (!displayMoveRangeButtons) {
    return children;
  }
  return /* @__PURE__ */ React.createElement(
    MoveRangeInner,
    {
      initialTimerangeFormat,
      setCurrentTimeRange,
      effectiveTimerange,
      initialTimerange,
      currentTimerange
    },
    children
  );
};
export default MoveRange;
